import { Dispatch } from 'redux';
import { batch } from 'react-redux';
import { ModalsDataTypes } from 'hooks/useModal';
import { ProposalProduct } from '@trnsact/trnsact-shared-types/src/generated';
import { deskingActions } from '../model';
import { defaultCashTerm } from '../constants';
import { AftermarketMenu, BuilderViewType, ProposalMenuId } from '../types';

interface Options {
  terms: number[];
  isCash: boolean;
  proposalMenuId: string;
  dispatch: Dispatch<any>;
  proposalsProductsIds: string[];
  proposalMenus: Record<ProposalMenuId, AftermarketMenu>;
  handleOpen: (data?: ModalsDataTypes['deskingNotifyAboutRemovedProductsDialog']) => void;
}

interface RemovedProductsOptions {
  proposalsProductsIds: string[];
  productsOnMenu: ProposalProduct[];
}

// Menu products whose ID is not among the products available for desking (expired, inactive, etc.)
export function getProductsRemovedFromMenu({ productsOnMenu, proposalsProductsIds }: RemovedProductsOptions) {
  const removed = productsOnMenu.filter(product => !proposalsProductsIds.includes(product.proposalProductId));

  return removed.filter(
    (product, index) => removed.findIndex(p => p.proposalProductId === product.proposalProductId) === index
  );
}

export function setMenuDeps({
  terms,
  isCash,
  dispatch,
  handleOpen,
  proposalMenus,
  proposalMenuId,
  proposalsProductsIds,
}: Options) {
  const financeProgramTerms = isCash ? [defaultCashTerm].map(Number) : terms;

  dispatch(deskingActions.setMenuToBuilder({ id: proposalMenuId, terms: financeProgramTerms.map(String) }));

  const maxTerm = Math.max(...financeProgramTerms);

  batch(() => {
    dispatch(deskingActions.toggleIsEditEquipmentStatus({ status: true }));
    dispatch(deskingActions.setMenuTerm({ term: String(maxTerm), index: financeProgramTerms.lastIndexOf(maxTerm) }));
    dispatch(
      deskingActions.setProductsConfigFromExistingMenu({
        terms: financeProgramTerms.map(String),
        data: proposalMenus[proposalMenuId].menuOptions,
      })
    );
    dispatch(deskingActions.updateMenuBuilderViewType({ type: BuilderViewType.AftermarketMenu }));
  });

  const productsRemovedFromMenu = getProductsRemovedFromMenu({
    proposalsProductsIds,
    productsOnMenu: proposalMenus[proposalMenuId].menuOptions.flatMap(option => option?.products ?? []),
  });

  if (productsRemovedFromMenu.length) {
    handleOpen({ removedProducts: productsRemovedFromMenu });

    dispatch(
      deskingActions.removeProductsFromMenu({
        ids: productsRemovedFromMenu.map(({ proposalProductId }) => proposalProductId),
      })
    );
  }
}
